







































  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { Filter, isFacetFilter } from '@empathyco/x-types';
  import { xComponentMixin } from '../../../../components/x-component.mixin';
  import { toKebabCase } from '../../../../utils/string';
  import FacetsMixin from '../facets.mixin';
  import { facetsXModule } from '../../x-module';
  import SelectedFilters from './selected-filters.vue';

  /**
   * Custom interface to provide a slot name to a Filter.
   *
   * @internal
   */
  interface RenderFilter {
    slotName: string;
    selectedFilter: Filter;
  }

  /**
   * This component renders a list of selected filters from every facet, or from the facet
   * ids passed as property. It uses the SelectedFilters component (state).
   *
   * It provides two slots: a scoped one which name is the filter facet id; and a default one.
   * Both exposes the filter and renders the filter label by default.
   *
   * The property "alwaysVisible" handles if the component is rendered if no filters are selected.
   *
   * @remarks It extends {@link FacetsMixin}.
   *
   * @public
   */
  @Component({
    components: { SelectedFilters },
    mixins: [xComponentMixin(facetsXModule)]
  })
  export default class SelectedFiltersList extends FacetsMixin {
    /**
     * Animation component that will be used to animate the selected filters list.
     *
     * @public
     */
    @Prop({ default: 'ul' })
    protected animation!: Vue | string;

    /**
     * Transforms a dictionary of Filters including the slot name.
     *
     * @param selectedFilters - A list of selected filters without slot name.
     *
     * @returns A dictionary of facets with the slot name.
     *
     * @internal
     */
    protected mapSlot(selectedFilters: Filter[]): RenderFilter[] {
      return selectedFilters.map(filter => ({
        slotName: isFacetFilter(filter) ? toKebabCase(filter.facetId as string) : 'default',
        selectedFilter: filter
      }));
    }
  }
